module.exports = __webpack_public_path__ + "img/4.3.fadd779c.png";